"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../constants");
var _colors = require("../../birch/colors");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var azaleaVersion = {
  linkColor: _constants.colors.mediumBlue,
  textDecoration: 'none'
};
var birchVersion = {
  linkColor: _colors.FullPalette.GREEN_700,
  textDecoration: 'underline'
};
var versionSelector = (0, _constants.buildVersionSelector)(azaleaVersion, birchVersion);
var Link = _styledComponents["default"].a.withConfig({
  displayName: "link__Link"
})(["font-family:Untitled Sans,sans-serif;font-size:14px;line-height:20px;color:", ";text-decoration:", ";", " &:hover{text-decoration:underline;}"], function (props) {
  var _props$theme;
  return versionSelector((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.name).linkColor;
}, function (props) {
  var _props$theme2;
  return versionSelector((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.name).textDecoration;
}, (0, _constants.fontWeight)('normal'));
var themedLink = (0, _styledComponents.withTheme)(Link);
var _default = themedLink;
exports["default"] = _default;